import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import EnrollPage from "@/pages/EnrollPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import QuestionnairePage from "@/pages/QuestionnairePage";
import AdminQuestionnairesPage from "@/pages/AdminQuestionnairesPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import PortalLoginPage from "@/pages/PortalLoginPage";
import PortalDashboardPage from "@/pages/PortalDashboardPage";
import PortalResetPasswordPage from "@/pages/PortalResetPasswordPage";
import SuperintendentDirectoryPage from "@/pages/SuperintendentDirectoryPage";
import InstantRecordsPage from "@/pages/InstantRecordsPage";
import PolicyPage from "@/pages/PolicyPage";
import NotFoundPage from "@/pages/NotFoundPage";
import VisitTracker from "@/components/VisitTracker";

export default function App() {
  return (
    <BrowserRouter>
      <VisitTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/enroll" element={<EnrollPage />} />
        <Route path="/enroll/confirmation/:enrollmentId" element={<ConfirmationPage />} />
        <Route path="/client-questionnaire" element={<QuestionnairePage />} />
        <Route path="/admin/questionnaires" element={<AdminQuestionnairesPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/portal/login" element={<PortalLoginPage />} />
        <Route path="/portal/reset" element={<PortalResetPasswordPage />} />
        <Route path="/portal" element={<PortalDashboardPage />} />
        <Route path="/superintendents" element={<SuperintendentDirectoryPage />} />
        <Route path="/records-request" element={<InstantRecordsPage />} />
        <Route path="/refund-policy" element={<PolicyPage />} />
        <Route path="/enrollment-policy" element={<PolicyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Toaster
        position="top-center"
        theme="light"
        toastOptions={{
          style: {
            fontFamily: "Arial, sans-serif",
            border: "1px solid #c9cbd0",
            borderRadius: "2px",
          },
        }}
      />
    </BrowserRouter>
  );
}
